'use server'

import { apiRequest, ApiResponse } from '../request'

export interface HrPayrollTable {
    id: number
    companyId: number
    type: string
    year: number
    month: number | null
    data: any
    active: boolean
    createdAt: string
}

const BASE = 'hr/payroll-tables'

export async function getPayrollTables(params?: { type?: string; year?: number }): Promise<ApiResponse<HrPayrollTable[]>> {
    return apiRequest<HrPayrollTable[]>(BASE, { params: params || {} })
}

export async function getPayrollTable(id: number): Promise<ApiResponse<HrPayrollTable>> {
    return apiRequest<HrPayrollTable>(`${BASE}/${id}`, {})
}

export async function createPayrollTable(data: any): Promise<ApiResponse<HrPayrollTable>> {
    return apiRequest<HrPayrollTable>(BASE, { data }, 'post')
}

export async function updatePayrollTable(id: number, data: any): Promise<ApiResponse<HrPayrollTable>> {
    return apiRequest<HrPayrollTable>(`${BASE}/${id}`, { data }, 'patch')
}

export async function deletePayrollTable(id: number): Promise<ApiResponse<void>> {
    return apiRequest<void>(`${BASE}/${id}`, {}, 'delete')
}

export async function seedPayrollTables(): Promise<ApiResponse<any>> {
    return apiRequest<any>(`${BASE}/seed`, {}, 'post')
}
